import React, {useState, createContext} from 'react';


export const GlobalContext = createContext();

export const GlobalProvider = (props) => {

    // const [user, setUser] = useState();
    // const [employees, setEmployees] = useState();

    const state = useState({
            user: '',
            employees: [], 
            schedule: [], 
            qualifications: [],
            editModal: {
                open: false,
                name: '',
                id: '',
                qualifications: []
            },
            editPositionModal: {
                open: false,
                name: '',
                id: '',
                qualifications: [],
                timeslot: ''
            }, 
            editQualificationModal: {
                open: false,
                name: '',
                id: '', 
                description: ''
            }, 
            messageModal: {
                header: '',
                message: ''
            },
            showDropFileComponent: true,
            employeeExcelData: [],
            employeeCells: [],
            positionCells: [],
            selectedCells: []
    });

    return (
        <GlobalContext.Provider value={state}>
            {props.children}
        </GlobalContext.Provider>
    );


}